"use strict";
exports.__esModule = true;
exports.Users = void 0;
var authGroups_1 = require("./authGroups");
var getAuthGroups = function (user) { return (user === null || user === void 0 ? void 0 : user.authGroups) || []; };
var isSystemAdmin = function (user) { return (getAuthGroups(user) || []).some(authGroups_1.AuthGroups.isSystemAdmin); };
var getAuthGroupBySurveyUuid = function (surveyUuid, includeSystemAdmin) {
    if (includeSystemAdmin === void 0) { includeSystemAdmin = true; }
    return function (user) {
        var authGroups = getAuthGroups(user);
        if (includeSystemAdmin && isSystemAdmin(user) && authGroups) {
            return authGroups[0];
        }
        return authGroups === null || authGroups === void 0 ? void 0 : authGroups.find(function (authGroup) { return (authGroup === null || authGroup === void 0 ? void 0 : authGroup.surveyUuid) === surveyUuid; });
    };
};
exports.Users = {
    isSystemAdmin: isSystemAdmin,
    getAuthGroupBySurveyUuid: getAuthGroupBySurveyUuid
};
//# sourceMappingURL=users.js.map